export default (function() {

    const defaults = {
    };

    function init() {

        $(".formField.is-file").each(function(){
            var container = $(this);
            new showFilename(container);
        });

    }

    var showFilename = function(container){

        var input = $(".formField-input input", container),
            output = $(".formField-filename", container);

        input.change(function (){

            var value = $(this).val(),
                filename = value.replace(/^.*[\\\/]/, '');

            output.val(filename);

        });

    };

    return {
        init: init
    }

})();